var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _c(
            "Row",
            { staticClass: "mb-16", attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "6" } }, [
                _c("div", { staticClass: "stat-widget primary-widget" }, [
                  _c(
                    "div",
                    { staticClass: "widget-icon" },
                    [_c("Icon", { attrs: { type: "md-globe" } })],
                    1
                  ),
                  _c("div", { staticClass: "widget-content" }, [
                    _c("div", { staticClass: "widget-num" }, [
                      _vm._v(_vm._s(_vm.totalRequests)),
                    ]),
                    _c("div", { staticClass: "widget-label" }, [
                      _vm._v("总请求数"),
                    ]),
                  ]),
                ]),
              ]),
              _c("Col", { attrs: { span: "6" } }, [
                _c("div", { staticClass: "stat-widget error-widget" }, [
                  _c(
                    "div",
                    { staticClass: "widget-icon" },
                    [_c("Icon", { attrs: { type: "md-alert" } })],
                    1
                  ),
                  _c("div", { staticClass: "widget-content" }, [
                    _c("div", { staticClass: "widget-num" }, [
                      _vm._v(_vm._s(_vm.errorCount)),
                    ]),
                    _c("div", { staticClass: "widget-label" }, [
                      _vm._v("本页错误"),
                    ]),
                  ]),
                ]),
              ]),
              _c("Col", { attrs: { span: "6" } }, [
                _c("div", { staticClass: "stat-widget warning-widget" }, [
                  _c(
                    "div",
                    { staticClass: "widget-icon" },
                    [_c("Icon", { attrs: { type: "md-time" } })],
                    1
                  ),
                  _c("div", { staticClass: "widget-content" }, [
                    _c("div", { staticClass: "widget-num" }, [
                      _vm._v(_vm._s(_vm.slowRequestCount)),
                    ]),
                    _c("div", { staticClass: "widget-label" }, [
                      _vm._v("本页慢查询(>2s)"),
                    ]),
                  ]),
                ]),
              ]),
              _c("Col", { attrs: { span: "6" } }, [
                _c("div", { staticClass: "stat-widget success-widget" }, [
                  _c(
                    "div",
                    { staticClass: "widget-icon" },
                    [_c("Icon", { attrs: { type: "md-speedometer" } })],
                    1
                  ),
                  _c("div", { staticClass: "widget-content" }, [
                    _c("div", { staticClass: "widget-num" }, [
                      _vm._v(_vm._s(_vm.averageDuration) + "ms"),
                    ]),
                    _c("div", { staticClass: "widget-label" }, [
                      _vm._v("本页平均响应"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("quick-filter", {
                    ref: "quickFilter",
                    on: {
                      "on-filter": _vm.handleQuickFilter,
                      "on-time-range": _vm.handleTimeRange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("search-card", {
                    attrs: {
                      form: _vm.mainTable.searchForm,
                      "table-load-event": _vm.getRequestLogs,
                      "table-search": _vm.mainTable.tableSearch,
                    },
                    on: { "on-reset": _vm.handleSearchReset },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("请求日志列表"),
                      ]),
                      _vm.filterCount > 0
                        ? _c(
                            "Tag",
                            {
                              staticClass: "filter-count",
                              attrs: { color: "primary" },
                            },
                            [
                              _vm._v(
                                "\n                            已筛选 " +
                                  _vm._s(_vm.filterCount) +
                                  " 条\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.hasActiveFilter
                        ? _c(
                            "Button",
                            {
                              attrs: {
                                size: "small",
                                type: "text",
                                icon: "md-close-circle",
                              },
                              on: { click: _vm.clearAllFilters },
                            },
                            [
                              _vm._v(
                                "\n                            清除筛选\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _c(
                        "Tooltip",
                        { attrs: { content: "刷新数据", placement: "top" } },
                        [
                          _c("Button", {
                            staticClass: "btns",
                            attrs: {
                              type: "default",
                              size: "small",
                              shape: "circle",
                              icon: "md-refresh",
                              loading: _vm.mainTable.loading,
                            },
                            on: { click: _vm.refreshData },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "Tooltip",
                        { attrs: { content: "导出Excel", placement: "top" } },
                        [
                          _c("Button", {
                            staticClass: "btns",
                            attrs: {
                              type: "primary",
                              size: "small",
                              shape: "circle",
                              icon: "ios-send",
                              loading: _vm.exporting,
                            },
                            on: { click: _vm.onExport },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "Tooltip",
                        { attrs: { content: "字段说明", placement: "top" } },
                        [
                          _c("Button", {
                            staticClass: "btns",
                            attrs: {
                              type: "primary",
                              size: "small",
                              shape: "circle",
                              icon: "md-help-circle",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openCloumnDescModal()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    ref: "paginationTable",
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getRequestLogs,
                      autoHeight: true,
                      showPage: true,
                    },
                    on: { "on-row-click": _vm.handleRowClick },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("request-log-detail-modal", { ref: "requestLogDetailModal" }),
      _c("request-log-column-desc-modal", { ref: "requestLogColumnDescModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }